import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { eskPartiApi } from '../services/api';

const n = (v: any) => (v ?? 0).toLocaleString('tr-TR', { maximumFractionDigits: 2 });
const tl = (v: any) => `${n(v)} ₺`;

export default function EskProjeDashboard() {
  const nav = useNavigate();
  const [yil, setYil] = useState<number | ''>(new Date().getFullYear());
  const [ozet, setOzet] = useState<any>(null);
  const [hata, setHata] = useState('');

  useEffect(() => {
    const params = yil ? { yil } : undefined;
    eskPartiApi.projeOzet(params).then(r => { setOzet(r.data); setHata(''); })
      .catch((e: any) => { setOzet(null); setHata(e.response?.status === 403 ? 'Proje panosunu görüntüleme yetkiniz yok.' : 'Özet hesaplanamadı'); });
  }, [yil]);

  return (
    <div>
      <div className="page-header">
        <h1>📊 ESK-TİGEM Proje Panosu</h1>
        <p>Tüm işletmeler genelinde damızlık düve / besilik sığır maliyet-kâr/zarar özeti</p>
      </div>

      <div className="card">
        <div className="toolbar">
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <label style={{ fontSize: 13 }}>Yıl:</label>
            <input type="number" className="search-input" style={{ width: 100 }} value={yil}
              onChange={e => setYil(e.target.value ? Number(e.target.value) : '')} placeholder="Tüm Yıllar" />
          </div>
        </div>
      </div>

      {hata && <div className="card"><div className="alert alert-danger">{hata}</div></div>}

      {ozet && (
        <>
          <div className="stats-grid">
            <div className="stat-card"><div className="stat-icon">📈</div><div><div className="stat-value">{tl(ozet.toplam_gelir)}</div><div className="stat-label">Toplam Gelir (Düve Partileri)</div></div></div>
            <div className="stat-card"><div className="stat-icon">💰</div><div><div className="stat-value">{tl(ozet.toplam_maliyet)}</div><div className="stat-label">Toplam Maliyet</div></div></div>
            <div className="stat-card"><div className="stat-icon">{ozet.kar_zarar >= 0 ? '✅' : '⚠️'}</div><div><div className="stat-value" style={{ color: ozet.kar_zarar >= 0 ? '#1e8449' : '#c0392b' }}>{tl(ozet.kar_zarar)}</div><div className="stat-label">Kâr/Zarar</div></div></div>
            <div className="stat-card"><div className="stat-icon">🏢</div><div><div className="stat-value">{ozet.isletmeler.length}</div><div className="stat-label">İşletme Sayısı</div></div></div>
          </div>

          <div className="card">
            <h3 style={{ marginTop: 0 }}>İşletme Karşılaştırma</h3>
            <p style={{ fontSize: 12, color: '#888', marginTop: -8 }}>
              Not: Besilik partilerinin geliri karkas kg cinsinden ayrıca izlenir, bu tablodaki TL toplamlarına dahil değildir.
            </p>
            <table>
              <thead><tr><th>İşletme</th><th>Parti Sayısı</th><th>Toplam Gelir</th><th>Toplam Maliyet</th><th>Kâr/Zarar</th><th></th></tr></thead>
              <tbody>
                {ozet.isletmeler.map((i: any) => (
                  <tr key={i.isletme_id}>
                    <td><strong>{i.isletme_ad}</strong></td>
                    <td>{i.parti_sayisi}</td>
                    <td>{tl(i.toplam_gelir)}</td>
                    <td>{tl(i.toplam_maliyet)}</td>
                    <td style={{ color: i.kar_zarar >= 0 ? '#1e8449' : '#c0392b', fontWeight: 600 }}>{tl(i.kar_zarar)}</td>
                    <td><button className="btn btn-primary btn-sm" onClick={() => nav(`/esk-parti?isletme=${i.isletme_id}`)}>Partileri Gör</button></td>
                  </tr>
                ))}
                {ozet.isletmeler.length === 0 && <tr><td colSpan={6} style={{ textAlign: 'center', color: '#999' }}>Kayıt yok</td></tr>}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
